import { useState } from "react";

type Props = { url: string; alt?: string | undefined; ratio?: number | undefined };

/** image{url, alt, ratio}: ratio(가로/세로)로 높이를 선반영, lazy, 실패 시 placeholder 배경만 남긴다. */
export function ImageBlock({ url, alt, ratio }: Props) {
  const [failed, setFailed] = useState(false);
  const style = ratio ? { aspectRatio: String(ratio) } : undefined;
  return (
    <figure className="block block--image" data-testid="block-image" style={style}>
      {!failed && <img src={url} alt={alt ?? ""} loading="lazy" style={style} onError={() => setFailed(true)} />}
    </figure>
  );
}
